import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "./AboutMe.css";
import { Link } from "react-router-dom";

class AboutMe extends Component {
  render() {
    return (
      <div className="AboutContainer">
        <header className="AboutHeader">
          <h1 className="AboutHeadline">
            <span className="NoBreak">Aspiring IT Systems Administrator</span>{" "}
            <span className="Separator" aria-hidden="true">
              |
            </span>{" "}
            <span className="NoBreak">Software Developer</span>
          </h1>
          <p className="AboutTagline">Linux • IT Support • Proxmox Homelab</p>
          <p className="AboutStack">
            Web stack: C# / ASP.NET Core • Angular • SQL Server
          </p>
        </header>

        <figure className="AboutPhoto">
          <img
            src="/profile.jpg"
            alt="Headshot of Elhacen Elmoustapha smiling, wearing a light blue button-up shirt against a plain light gray background"
            width="2048"
            height="1362"
          />
        </figure>

        <div className="AboutBody">
          <p>
            I’m Elhacen, a Computer Science and Engineering graduate based in
            Louisville, Kentucky. My professional background includes software
            development, quality assurance, and data integrity. I’m working
            toward a career in IT, with a focus on Linux and systems
            administration, while continuing to build my web development skills.
          </p>
          <p>
            I started my Proxmox homelab because I wanted to keep learning after
            college. It is my hands-on environment for practicing Linux and
            Windows Server administration, virtualization, networking,
            monitoring, and troubleshooting. I also host this website from my
            lab using an LXC container, Nginx, Cloudflare Tunnel, and GitHub
            Actions.
          </p>
          <p>
            My development experience includes C#/.NET, Angular, SQL Server,
            Python/Flask, and React. I’m interested in opportunities in IT
            support and junior systems administration where I can contribute my
            troubleshooting, testing, and development experience while
            continuing to learn.
          </p>

          <nav className="AboutActions" aria-label="Explore this site">
            <Link to="/Projects" className="ActionButton ActionPrimary">
              View My Projects
            </Link>
            <Link to="/Experience" className="ActionButton">
              View My Experience
            </Link>
            <Link to="/Contact" className="ActionButton">
              Contact Me
            </Link>
          </nav>
        </div>
      </div>
    );
  }
}

export default AboutMe;
